module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/widget-status/widget-status.component.scss
// module id = ./src/app/shared/widget-status/widget-status.component.scss
// module chunks = main